"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { Container, SectionSubHeading, SectionTitle } from "@/components";
import { servicePrinciples } from "@/data/ServicePrinciplesData";
import { cardRise, cardStagger, fadeInUp } from "@/lib/animation/variant";
const ServicePrinciples = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <motion.div custom={0} initial="hidden" whileInView="visible" viewport={t0} variants={fadeInUp}><SectionSubHeading subtitle="Why studios get replaced, and we don't" className="text-primary" /></motion.div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      once: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="space-y-2">{t1}<motion.div custom={1} initial="hidden" whileInView="visible" viewport={t2} variants={fadeInUp}><SectionTitle title="Six things we refuse to outsource." className="text-white" /></motion.div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <motion.p custom={2} initial="hidden" whileInView="visible" viewport={{
      once: true
    }} variants={fadeInUp} className="max-w-3xl text-base leading-relaxed font-medium text-white/60 md:text-lg">Agencies get swapped out when the strategy that won the pitch never survives contact with the build. These six are the reasons ours does — and every one of them is something you can check on a project we have already shipped.</motion.p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      once: true,
      amount: 0.15
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="w-full rounded-4xl bg-accent-foreground py-20 md:py-28"><Container className="flex flex-col gap-8 px-4 lg:px-10">{t3}{t4}<motion.div initial="hidden" whileInView="show" viewport={t5} variants={cardStagger} className="mt-6 grid gap-5 md:grid-cols-2 xl:grid-cols-3">{servicePrinciples.map(_temp)}</motion.div></Container></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default ServicePrinciples;
function _temp(principle) {
  const Icon = principle.icon;
  return <motion.article key={principle.number} variants={cardRise} className="flex flex-col gap-4 rounded-2xl border border-white/15 p-7 md:p-8"><span className="flex size-11 shrink-0 items-center justify-center rounded-full border border-primary/40"><Icon className="size-5 text-primary" strokeWidth={1.6} /></span><span className="font-mono text-[10px] tracking-[0.24em] text-white/40">{principle.number}</span><h3 className="text-xl leading-tight font-black tracking-tighter text-white uppercase">{principle.title}</h3><p className="text-sm leading-relaxed text-white/60">{principle.description}</p></motion.article>;
}